import { ResultsState, hasData } from '../../../store/state'
import { isValgResultat } from '../../../domain'
import { Fragment, h } from 'preact'
import { Message } from '../../../../lib/intl/Message'

import s from './Status.modules.css'

type State = 'empty' | 'loading' | 'reloading' | 'success' | 'error' | 'locked'

function renderMessage(
  state: State,
  resultatType: 'Prognose' | 'PrognoseOverstyring' | 'Resultat',
  opptaltProsent: number
) {
  switch (state) {
    case 'reloading':
    case 'success':
      switch (resultatType) {
        case 'Prognose':
          return <Message id="status-prognose" values={{ prosent: opptaltProsent }} />
        case 'PrognoseOverstyring':
          return <Message id="status-prognoseoverstyring" values={{ prosent: opptaltProsent }} />
        case 'Resultat':
          return <Message id="status-resultat" values={{ prosent: opptaltProsent }} />
        default:
          return <div />
      }
    case 'loading':
      return <Message id="status-laster" />
    case 'locked':
      return <div />
    default:
      return (
        <div>
          <span>&nbsp;</span>
        </div>
      )
  }
}

type Props = {
  resultat: ResultsState
}
export function Status(props: Props) {
  const { resultat } = props
  let opptaltProsent = 0
  let resultatType
  if (hasData(resultat) && isValgResultat(resultat.data)) {
    opptaltProsent = resultat.data.opptalt ? resultat.data.opptalt.forelopig : 0
    resultatType = resultat.data.resultatType
  }

  return (
    <Fragment>
      <div class={s.barContainer}>
        <div class={s.bar} style={{ width: `${opptaltProsent}%` }} />
      </div>
      <div class={s.status}>{renderMessage(resultat.state, resultatType, opptaltProsent)}</div>
    </Fragment>
  )
}
